export const switchProps = {
    height: 24,
    width: 42,
    onColor: '#2B5ABC',
    uncheckedIcon: false,
    checkedIcon: false
};
